<template lang="html">
	<div class="master-legals column">
		<router-link :to="{ name: 'Login' }" v-if="!isUser">
			<logo />
		</router-link>
		<div class="ctn-header" v-else>
			<my-header :menu="menu" @notif-open="notifPanelActive = true" :notif="false" :help="true"></my-header>
		</div>
		<router-view />
		<my-footer v-if="isUser"/>
	</div>
</template>

<script>
import myHeader from '@/common/components/header'
import myFooter from '@/common/components/footer'
import { mapGetters } from 'vuex'
import Logo from '@/common/components/Logo.vue'

export default {
	name: 'Legal',
	components: {
		myHeader,
		Logo,
		myFooter
	},
	data () {
		return {
			logo: Logo
		}
	},
	computed: {
		...mapGetters({
			isUser: 'isAuthenticated',
			user: 'user'
		}),
		menu () {
			if (this.user.role === 'ADVISOR') {
				return [
					{
						key: 0,
						name: '<span class="icon-nav-admin-stat"></span> Accueil',
						uri: 'Home'
					},
					{
						key: 1,
						name: '<span class="icon-nav-operation"></span> Opérations',
						uri: 'Transactions'
					},
					{
						key: 2,
						name: '<span class="icon-nav-actu"></span> Actualités',
						uri: 'Actualities'
					}
				]
			} else {
				return [
					{
						key: 0,
						name: '<span class="icon-nav-actu"></span> Actualités',
						uri: 'IndexActualities'
					},
					//					{
					//						key: 1,
					//					name: '<span class="icon-nav-placements"></span> Mes placements',
					//						uri: 'MyInvestments'
					//					},
					{
						key: 2,
						name: '<span class="icon-nav-conseiller"></span> Conseiller',
						uri: 'Advisor'
					},
					{
						key: 3,
						name: '<span class="icon-nav-docs"></span> Mes documents',
						uri: 'Documents'
					}
				]
			}
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/Legal/index.vue